import type { CSSProperties, ReactNode } from 'react'

export interface DayBlockProps {
  date: string
  summary: string
  children: ReactNode
}

export function DayBlock({ date, summary, children }: DayBlockProps) {
  const wrapperStyle: CSSProperties = { marginBottom: 'var(--space-4)' }
  const headerStyle: CSSProperties = {
    display: 'flex', alignItems: 'center', gap: 'var(--space-2)',
    padding: 'var(--space-2) var(--space-3)',
    borderBottom: '1px solid var(--color-border)',
    marginBottom: 'var(--space-2)',
  }
  const datePillStyle: CSSProperties = {
    background: 'var(--color-surface)',
    border: '1px solid var(--color-border)',
    borderRadius: 'var(--radius-sm)',
    padding: '3px 8px',
    color: 'var(--color-text)',
    fontWeight: 700,
    fontSize: 'var(--font-size-xs)',
    fontVariantNumeric: 'tabular-nums',
  }
  const summaryStyle: CSSProperties = {
    color: 'var(--color-text-faint)',
    fontSize: 'var(--font-size-xs)',
  }
  return (
    <div style={wrapperStyle}>
      <div style={headerStyle}>
        <span style={datePillStyle}>{date}</span>
        <span style={summaryStyle}>{summary}</span>
      </div>
      <div>{children}</div>
    </div>
  )
}
